/// <reference path="./dto/com.rico.sb2.service.system.ts" />

import {createHtmlElement} from "./lib/domFunctions";
import {escapeHTML} from "./lib/escapeHTML";
import JournalListItem = com.rico.sb2.service.system.JournalListItem;
import {moment} from "./boot";

export function journalLevelOrdinalOrDefault(level: string | null) {
	const index = ['TRACE', 'INFO', 'WARNING', 'ERROR'].indexOf(level || '');
	return index < 0 ? 1 : index;
}

export function createJournalEventElement(m: JournalListItem, unread: boolean = false): HTMLLIElement {
	const eventLiClass = {
		'ERROR': 'alert alert-danger',
		'WARNING': 'alert alert-warning',
		'TRACE': 'alert alert-info'
	}[m.level] || 'alert alert-default';

	const eventLiIcon = {
		'ERROR': 'fa-exclamation-triangle',
		'WARNING': 'fa-exclamation-circle',
		'TRACE': 'fa-bug',
	}[m.level] || 'fa-sensor text-white';

	const userNameText = typeof m.userName === "string" && m.userName.length > 0
		? `<span class="fw-bolder fs125 me-3 text-success">${escapeHTML(m.userName)}</span>`
		: ``;

	return createHtmlElement('li', {'class': `${eventLiClass} ${unread ? 'event-unread ' : ''}rounded-0 m-0`}, `
<div class="d-flex text-muted fs80 justify-content-between">
	<span>
		${userNameText}
		<span data-ago-from="${m.time}">${moment.utc(m.time).fromNow()}</span>
	</span>
	<span>${escapeHTML(moment(m.time).format('DD.MM.YYYY HH:mm:ss'))}</span>
</div>
<i class="fal ${eventLiIcon} me-2" title="${m.level}"></i>
<span class="text-break d-inline">${escapeHTML(m.message)}</span>
	`);
}

export function updateJournalEventAgoOnElement(element: HTMLElement) {
	const from = parseInt(element.getAttribute('data-ago-from') || '');
	if (Number.isFinite(from)) {
		const ago = moment.utc(from).fromNow();
		if (ago != element.innerText)
			element.innerText = ago;
	}
}

export function updateJournalEventsAgo(list: HTMLElement) {
	list.querySelectorAll<HTMLElement>('[data-ago-from]').forEach(element => {
		updateJournalEventAgoOnElement(element);
	})
}
